import React, { useContext, useEffect, useState, useRef } from "react";
import { Controller, set, useForm } from "react-hook-form";
import { FormInput } from "../../components/FormInput";
import { useTranslation } from "react-i18next";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import NoInfo from "../../components/NoInfo";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  checkDpSuccess,
  getMaskedString,
  getFileBase64,
  splitFileExtension,
  splitFileName,
} from "../../utility/service/tool-service";
import { deleteCompanyAccount, queryAllCompaniesList } from "../../utility/service/companybind-service";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import CusContractTable from "./component/CusContractTable";
import { useFuncId } from "../../router/menuRouterMapper";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import FileUploadDialog from "../../components/dialog/FileUploadDialog";
import { useEditableFlag } from "../../hooks/useEditableFlag";


const CompanyBinding_Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, loading] = useContext(SystemLoading);
  const { itemObj, setItemObj, action, setAction, currentStatus, setCurrentStatus } = useOutletContext();
  const [rows, setRows] = useState([]);
  const [companySeq, setCompanySeq] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [contractDialog, setContractDialog] = useState(false);
  const [contractList, setContractList] = useState([]);
  const [maskView, setMaskView] = useState(false);
  const chsFuncId = useFuncId();
  const [delAcctDialog, setDelAcctDialog] = useState(false);
  const [delObj, setDelObj] = useState({});
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [effectiveTypeList, setEffectiveTypeList] = useState([]);
  const [companyLevelList, setCompanyLevelList] = useState([]);
  const isEditable = useEditableFlag('B20102');

  const [uploadFileDialog, setUploadFileDialog] = useState(false);

  const esgClientId = [
    {
      label: t("company.a"),
      value: "A",
    },
    {
      label: t("company.b"),
      value: "B",
    },
  ];

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      keywordSearch: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const onSubmit = (data) => {
    let reqBody = {
      keywordSearch: data.keywordSearch,
      companyType: data.companyType,
      effectiveType: data.effectiveType,
      companyLevel: data.companyLevel,
    };
    if (data.status !== null && data.status !== "" && data.status !== undefined) {
      reqBody.status = data.status;
    }
    axios_queryAllCompaniesList(reqBody);
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  //查詢更多
  const btnReadMore = () => {
    let reqBody = {
      keywordSearch: getValues("keywordSearch"),
      companyType: getValues("companyType"),
      companySeq: companySeq,
      effectiveType: getValues("effectiveType"),
      companyLevel: getValues("companyLevel"),
    };
    let STATUS = getValues("status");
    if (STATUS !== null && STATUS !== "" && STATUS !== undefined) {
      reqBody.status = STATUS;
    }
    axios_queryAllCompaniesList(reqBody, true);
  };

  const statusBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <span className={`p-tag p-tag-${rowData?.status === "0" ? "success" : "danger"}`}>
            {getStatusLabel(rowData?.status)}
          </span>
        </>
      );
    }
  };

  const getStatusLabel = (value) => {
    const item = statusList?.find((item) => item.subitemNo === value);
    return item ? item.subitemName : null;
  };

  const typeBodyTemplate = (rowData, props) => {
    if (rowData) {
      return <>{getLabelByValue(rowData?.type)}</>;
    }
  };

  const getLabelByValue = (value) => {
    const item = esgClientId?.find((item) => item.value === value);
    return item ? item.label : null;
  };

  const showContractInfo = (item) => {
    setContractList([
      {
        status: t("upgradeRequest"),
        time: item?.companiesContractData?.upgradeDateTime,
        personnel: item?.companiesContractData?.upgradeUser,
        companiesContractId: item?.companiesContractData?.companiesContractId,
        companySeq: item?.companySeq,
      },
      {
        status: t("contractUpdate"),
        time: item?.companiesContractData?.contractDateTime,
        personnel: item?.companiesContractData?.contractUser,
        companiesContractId: item?.companiesContractData?.companiesContractId,
        companySeq: item?.companySeq,
      },
      {
        status: t("invoiceUpdate"),
        time: item?.companiesContractData?.invoiceDateTime,
        personnel: item?.companiesContractData?.invoiceUser,
        companiesContractId: item?.companiesContractData?.companiesContractId,
        companySeq: item?.companySeq,
      },
    ]);
    setContractDialog(true);
  };

  const editItem = (item, act) => {
    setItemObj(item);
    navigate(act);
    setAction(act);
  };

  const deleteAccountItem = (item) => {
    setAction("deleteAccount");
    setDelObj(item);
    setDelAcctDialog(true);
  };

  const editBinding = (item) => {
    setItemObj(item);
    if (item?.status === "1") {
      navigate("activate");
      setAction("activate");
    } else if (item?.status === "0") {
      navigate("extend");
      setAction("extend");
    }
  };

  useEffect(() => {
    let comType = "";
    if (JSON.stringify(currentStatus) !== "{}") {
      comType = currentStatus?.type;
    } else {
      comType = "A";
    }
    setValue("companyType", comType, { shouldValidate: true });
    axios_queryAllCompaniesList({
      companyType: comType,
    });
    axios_getSubItemsByItemNo("COMPANY_STATUS", 23).then(setStatusList);
    axios_getSubItemsByItemNo("EFFECTIVE_TYPE", 17).then(setEffectiveTypeList);
    axios_getSubItemsByItemNo("COMPANY_LEVEL", 35).then(setCompanyLevelList);
  }, []);

  const axios_queryAllCompaniesList = (reqBody, readMore = false) => {
    checkLoading(loading);
    setCurrentStatus({
      type: reqBody.companyType,
    });
    queryAllCompaniesList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody?.companyList;
          if (data?.length > 0) {
            setCompanySeq(data[data?.length - 1].companySeq);
            if (readMore === true) {
              setRows((pre) => {
                return [...pre, ...data];
              });
            } else {
              setRows((pre) => {
                return [...data];
              });
            }
          } else {
            if (readMore === false) {
              setRows([]);
            }
          }
        } else {
          if (readMore === false) {
            setRows([]);
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  const updateContract = () => {
    setContractDialog(false); //合約更新成功後 將進度查詢視窗關閉
    handleSubmit(onSubmit)(); //刷新清單資料
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button
            tooltip={t("button.detail")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "detail");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
          <Button
            tooltip={t("button.upload")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!isEditable}
            onClick={() => {
              uploadFile(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-upload" />
          </Button>
          <Button
            disabled={rowData?.companiesContractData === null}
            tooltip={t("progressCheck")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              showContractInfo(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-list-check" />
          </Button>
          <Button
            disabled={rowData.status === "X" || !isEditable}
            tooltip={`${rowData?.status === "0" ? t("extend") : t("activateAcc")}`}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editBinding(rowData);
            }}
          >
            <FontAwesomeIcon icon={`fa-solid ${rowData?.status === "0" ? "fa-clock" : "fa-lock"}`} />
          </Button>
          <Button
            disabled={rowData?.status === "1" || rowData.status === "X"}
            tooltip={t("cooperate")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "cooperate");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-handshake" />
          </Button>
          <Button
            tooltip={t("button.deleteAccount")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!isEditable}
            onClick={() => {
              deleteAccountItem(rowData, "cooperate");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-user-slash" />
          </Button>
        </>
      );
    }
  };

  const masKAccountTemplate = (rowData, props) => {
    if (rowData) {
      return <>{!maskView ? getMaskedString("account", rowData?.[props?.field]) : rowData?.[props?.field]}</>;
    }
  };

  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "V",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  const confirmDelAccount = () => {
    deleteCompanyAccount({ companySeq: delObj?.companySeq }).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.deleteAccount") + " " + t("message.success"));
        setDelAcctDialog(false);
        let reqBody = {
          keywordSearch: getValues("keywordSearch"),
          companyType: getValues("companyType"),
        };
        let STATUS = getValues("status");
        if (STATUS !== null && STATUS !== "" && STATUS !== undefined) {
          reqBody.status = STATUS;
        }
        axios_queryAllCompaniesList(reqBody);
      }
    });
  };

  const companyLevelNameTemplate = (rowData, props) => {
    if (rowData) {
      switch (rowData?.effectiveType) {
        case "0": //正式
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--primary-color)", fontSize: "1rem" }} className="contract-str">
                {t("formal")}
              </span>
            </div>
          );
        case "1": //試用
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--gray-400)", fontSize: "1rem" }} className="contract-str">
                {t("trial")}
              </span>
            </div>
          );
        default:
          return null;
      }
    }
  };

  const uploadFile = (item) => {
    setItemObj(item);
    setUploadFileDialog(true);
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form
            className="flex flex-wrap align-items-center col-12"
            onSubmit={handleSubmit(onSubmit)}
            onKeyDown={checkKeyDown}
          >
            {/* 類型 */}
            <div className="col-12 lg:col-3">
              <label htmlFor="releaseStatus" className="form-label required">
                {t("type")}
              </label>
              <Controller
                name="companyType"
                control={control}
                rules={{ required: { value: true, message: t("validation.required") } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    optionLabel="label"
                    optionValue="value"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="companyType"
                    control={control}
                    options={esgClientId}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/* 狀態 */}
            <div className="col-12 lg:col-3">
              <label htmlFor="releaseStatus" className="form-label">
                {t("status")}
              </label>
              <Controller
                name="status"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="status"
                    control={control}
                    options={statusList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/*授權類型*/}
            <div className="col-12 lg:col-3">
              <label htmlFor="effectiveType" className="form-label">
                {t("authorizationType")}
              </label>
              <Controller
                name="effectiveType"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="effectiveType"
                    control={control}
                    options={effectiveTypeList}
                    className={"w-full"}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/*會員等級*/}
            <div className="col-12 lg:col-3">
              <label htmlFor="companyLevel" className="form-label">
                {t("membershipLevel")}
              </label>
              <Controller
                name="companyLevel"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="membershipLevel"
                    control={control}
                    options={companyLevelList}
                    className={"w-full"}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/* 關鍵字 */}
            <div className="col-12">
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                type="text"
                placeholder={``}
                labelClass="control-label"
                enterClick={checkKeyDown}
                labelText={t("keyword")}
              />
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button disabled={!isValid} type="submit" label={t("button.query")} />
            </div>
          </form>
        </div>
      </div>
      {/* <div className="" style={{ top: "28px" }}>
        <Button
          type="button"
          icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
          severity="secondary"
          disabled={rows?.length === 0}
          onClick={() => {
            setMaskView((prev) => {
              if (!prev) {
                axios_updateAuditEyesEvent();
              }
              return !prev;
            });
          }}
        />
      </div> */}
      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            stripedRows
            resizableColumns
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: "55rem" }}
            value={rows}
            footer={
              rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
            }
            emptyMessage={<NoInfo panel="table" />}
          >
            <Column field="taxIdNum" header={t("company_num")} />
            <Column
              field="name"
              header={t("organName")}
              style={{
                width: "300px",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            />
            {/* <Column field="leader" header={t("companyLeader")} body={masKAccountTemplate} />
            <Column field="email" header={`${t("company.a")} email`} body={masKAccountTemplate} /> */}
            {/* <Column field="address"  header={t('address')} style={{ minWidth: '100px' }} body={masKAccountTemplate} /> */}
            {/* <Column field="industryCodeName" header={t("industry")} /> */}
            {/* <Column field="type" header={t("type")} body={typeBodyTemplate} /> */}
            <Column field="status" header={t("status")} body={statusBodyTemplate} />
            <Column field="effectiveType" header={t("authorizationType")} body={companyLevelNameTemplate} />
            <Column field="createDate" header={t("applicationDate")} />
            <Column field="companyLevel" header={t("membershipLevel")} />
            <Column body={actionBodyTemplate} header={t("action")} frozen alignFrozen="right" />
          </DataTable>
        </div>
      </div>

      {/* 合約 */}
      <PrimeDialog
        visible={contractDialog}
        isShowConfBtn={false}
        onClose={() => {
          setContractDialog(false);
        }}
        title={t("progressCheck")}
        bodyTemplate={<CusContractTable contractList={contractList} updateContract={updateContract} isAdmin={true} />}
      />

      {/* 註銷帳戶 */}
      <PrimeConfirmDialog
        visible={delAcctDialog}
        onClose={() => {
          setDelAcctDialog(false);
        }}
        onConfirm={() => {
          confirmDelAccount();
        }}
        title={t("button.deleteAccount")}
        bodyTemplate={
          <>
            <div className="form-label">{t("confDelAccountAsk")}</div>
            <div className="form-label">
              {t("org_name")} : {delObj?.name}
            </div>
          </>
        }
      />

      {/* 上傳檔案 */}
      <FileUploadDialog
        uploadFileDialog={uploadFileDialog}
        setUploadFileDialog={setUploadFileDialog}
        targeFilePath={"companies_files/manager/"}
        targeFileCateCode={"companies_files"}
        targeRefId={itemObj?.companySeq}
        fileId={itemObj?.fileId}
        fileName={itemObj?.fileName}
        fileExtension={itemObj?.fileExtension}
        filePath={itemObj?.filePath}
        filePathSml={itemObj?.filePathSml}
        uploadQuery={() => {
          axios_queryAllCompaniesList(
            {
              keywordSearch: getValues("keywordSearch"),
              companyType: getValues("companyType"),
              effectiveType: getValues("effectiveType"),
              companyLevel: getValues("companyLevel"),
              status: getValues("status"),
            },
            false
          );
        }}
        deleteQuery={() => {
          axios_queryAllCompaniesList(
            {
              keywordSearch: getValues("keywordSearch"),
              companyType: getValues("companyType"),
              effectiveType: getValues("effectiveType"),
              companyLevel: getValues("companyLevel"),
              status: getValues("status"),
            },
            false
          );
        }}
      />
    </>
  );
};

export default CompanyBinding_Index;
